import firebase from '@/firebase'
import { FS_COLLECTIONS } from '@/firebase'
const db = firebase.firestore()

const store = {
  state: {
    listaReportes: [],
    listaReportesVentasMostrador: [],
  },
  getters: {
    listaReportes: state => {
      return state.listaReportes
    },
    listaReportesVentasMostrador: state => {
      return state.listaReportesVentasMostrador
    },
  },
  mutations: {
    ASIGNA_CATALOGO_REPORTES(state, listaReportes) {
      state.listaReportes = listaReportes
    },
    ASIGNA_CATALOGO_REPORTES_VENTAS_MOSTRADOR(state, listaReportes) {
      state.listaReportesVentasMostrador = listaReportes
    },
  },
  actions: {

    cargarReportes({ commit, getters }, fecha) {

      let start = new Date(fecha.fecha_inicio);
      let end = new Date(fecha.fecha_fin);
      end.setHours(23);
      end.setMinutes(59); // timestamp
      end = new Date(end); // Date object HORA:60 EXACTAMENTE
      
      db.collection(FS_COLLECTIONS.FRANQUICIAS)
      .doc(getters.franquicia.id).collection('ServiciosCasos')
      .where('servicio_generico.info.fecha_alta', '>', start)
      .where('servicio_generico.info.fecha_alta', '<', end)
      .orderBy("servicio_generico.info.fecha_alta").get().then(snapshot => {
        const jsonvalue = [];
        snapshot.forEach(docs => jsonvalue.push(docs.data()))
        commit('ASIGNA_CATALOGO_REPORTES', [])
        commit('ASIGNA_CATALOGO_REPORTES', jsonvalue)
      })

      db.collection(FS_COLLECTIONS.FRANQUICIAS)
      .doc(getters.franquicia.id).collection(FS_COLLECTIONS.VENTAS_MOSTRADOR)
      .where('servicio_generico.info.fecha_alta', '>', start)
      .where('servicio_generico.info.fecha_alta', '<', end)
      .orderBy("servicio_generico.info.fecha_alta").get().then(snapshot => {
        const jsonvalueV = [];
        snapshot.forEach(docs => jsonvalueV.push(docs.data()))
        commit('ASIGNA_CATALOGO_REPORTES_VENTAS_MOSTRADOR', [])
        commit('ASIGNA_CATALOGO_REPORTES_VENTAS_MOSTRADOR', jsonvalueV)
      })

    },

  }
}

export default store


// WEBPACK FOOTER //
// ./src/store/reportes/reportes.js